(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[851],{

/***/ 76011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ EmailForm; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/lodash/sortBy.js
var sortBy = __webpack_require__(89734);
var sortBy_default = /*#__PURE__*/__webpack_require__.n(sortBy);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-select/dist/react-select.browser.esm.js + 15 modules
var react_select_browser_esm = __webpack_require__(25397);
// EXTERNAL MODULE: ./node_modules/@sentry/minimal/esm/index.js
var esm = __webpack_require__(39666);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./src/api/internal/mailer.js





var baseURL = "".concat("https://kritikos-cxm-production.herokuapp.com");
function sendMail(_x) {
  return _sendMail.apply(this, arguments);
}

function _sendMail() {
  _sendMail = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(formData) {
    var response, error;
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (formData) {
              _context.next = 3;
              break;
            }

            throw Error('Request failed, no data given.');

          case 3:
            _context.next = 5;
            return axios_default().post("".concat(baseURL, "/api/v2/proxies/mailer"), formData, {
              headers: {
                'Content-Type': 'multipart/form-data',
                appId: "kritikos-web"
              }
            });

          case 5:
            response = _context.sent;

            if (!(response.status !== 200)) {
              _context.next = 8;
              break;
            }

            throw Error('Request failed');

          case 8:
            return _context.abrupt("return", {});

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            (0,esm/* captureException */.Tb)(error);
            error = get_default()(_context.t0, 'response.data.error', {});
            return _context.abrupt("return", {
              error: error
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));
  return _sendMail.apply(this, arguments);
}
;// CONCATENATED MODULE: ./src/constants/contactForm.js
var DEFAULT_RECEIVER = 'customer.service@anedik.com.gr';
var EMAIL_SUBJECTS_MAP = {
  kritikos: {
    order: {
      value: DEFAULT_RECEIVER,
      label: 'Για την παραγελία μου'
    },
    shop: {
      value: DEFAULT_RECEIVER,
      label: 'Για ένα κατάστημα'
    },
    default: {
      value: DEFAULT_RECEIVER,
      label: 'Γενικά'
    },
    franchise: {
      value: 'franchise@anedik.com.gr',
      label: 'Franchise'
    },
    career: {
      value: 'cv@anedik.com.gr',
      label: 'Εργασία'
    }
  },
  ariadni: {
    order: {
      value: DEFAULT_RECEIVER,
      label: 'Για την παραγελία μου'
    },
    shop: {
      value: DEFAULT_RECEIVER,
      label: 'Για ένα κατάστημα'
    },
    default: {
      value: DEFAULT_RECEIVER,
      label: 'Γενικά'
    },
    franchise: {
      value: 'franchise@anedik.com.gr',
      label: 'Franchise'
    },
    career: {
      value: 'cv@anedik.com.gr',
      label: 'Εργασία'
    }
  }
};
// EXTERNAL MODULE: ./src/store/loader.js
var loader = __webpack_require__(58766);
// EXTERNAL MODULE: ./src/components/Buttons/Buttons.jsx
var Buttons = __webpack_require__(3805);
// EXTERNAL MODULE: ./src/components/GenericModalV2.jsx
var GenericModalV2 = __webpack_require__(29962);
// EXTERNAL MODULE: ./src/components/EmailForm/EmailForm.module.scss
var EmailForm_module = __webpack_require__(21058);
var EmailForm_module_default = /*#__PURE__*/__webpack_require__.n(EmailForm_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/EmailForm/EmailForm.jsx





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
















var emailMap = EMAIL_SUBJECTS_MAP["kritikos"];
var subjectOptions = Object.entries(emailMap).map(function (_ref) {
  var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
      key = _ref2[0],
      label = _ref2[1].label;

  return {
    value: key,
    label: label
  };
});
function EmailForm(_ref3) {
  var slug = _ref3.slug,
      _ref3$positions = _ref3.positions,
      positions = _ref3$positions === void 0 ? [] : _ref3$positions,
      _ref3$areas = _ref3.areas,
      areas = _ref3$areas === void 0 ? [] : _ref3$areas;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)({
    firstName: '',
    lastName: '',
    birthday: '',
    gender: '',
    telephone: '',
    mobilePhone: '',
    email: '',
    address: '',
    addressNumber: '',
    postal: '',
    city: '',
    area: '',
    position: '',
    message: ''
  }),
      values = _useState[0],
      setValues = _useState[1];

  var _useState2 = (0,react.useState)([]),
      availableAreas = _useState2[0],
      setAvailableAreas = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      availablePositions = _useState3[0],
      setAvailablePositions = _useState3[1];

  var _useState4 = (0,react.useState)('Επίλεξε Αρχείο'),
      inputText = _useState4[0],
      setInputText = _useState4[1];

  var _useState5 = (0,react.useState)(),
      selectedPosition = _useState5[0],
      setSelectedPosition = _useState5[1];

  var _useState6 = (0,react.useState)(),
      selectedArea = _useState6[0],
      setSelectedArea = _useState6[1];

  var _useState7 = (0,react.useState)(),
      selectedGender = _useState7[0],
      setSelectedGender = _useState7[1];

  var _useState8 = (0,react.useState)(),
      startDate = _useState8[0],
      setStartDate = _useState8[1];

  var _useState9 = (0,react.useState)({}),
      modal = _useState9[0],
      setModal = _useState9[1];

  var initialSubject = subjectOptions.find(function (v) {
    return v.value === slug;
  }) || undefined;

  var _useState10 = (0,react.useState)(initialSubject),
      selectedSubject = _useState10[0],
      setSelectedSubject = _useState10[1];

  (0,react.useEffect)(function () {
    var positionsSorted = sortBy_default()(positions, function (position) {
      var _position$fields;

      return position === null || position === void 0 ? void 0 : (_position$fields = position.fields) === null || _position$fields === void 0 ? void 0 : _position$fields.index;
    });
    var positionsFormated = positionsSorted.map(function (position) {
      var _position$fields2, _position$fields3;

      return {
        value: position === null || position === void 0 ? void 0 : (_position$fields2 = position.fields) === null || _position$fields2 === void 0 ? void 0 : _position$fields2.position,
        label: position === null || position === void 0 ? void 0 : (_position$fields3 = position.fields) === null || _position$fields3 === void 0 ? void 0 : _position$fields3.position
      };
    });
    var areasFormatted = areas.map(function (area) {
      var _area$fields, _area$fields2;

      return {
        value: area === null || area === void 0 ? void 0 : (_area$fields = area.fields) === null || _area$fields === void 0 ? void 0 : _area$fields.area,
        label: area === null || area === void 0 ? void 0 : (_area$fields2 = area.fields) === null || _area$fields2 === void 0 ? void 0 : _area$fields2.area
      };
    });
    var areasSorted = sortBy_default()(areasFormatted, 'value');
    setAvailablePositions(positionsFormated);
    setAvailableAreas(areasSorted);
  }, []);
  var style = {
    control: function control(base) {
      return _objectSpread(_objectSpread({}, base), {}, {
        border: EmailForm_module.modalBorder,
        borderRadius: '0.25rem',
        '&:hover': {
          border: EmailForm_module.modalBorder
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(base, state) {
      return _objectSpread(_objectSpread({}, base), {}, {
        transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
      });
    },
    option: function option(styling) {
      return _objectSpread(_objectSpread({}, styling), {}, {
        color: EmailForm_module.inputTextColor
      });
    }
  };

  function setTheme(theme) {
    return _objectSpread(_objectSpread({}, theme), {}, {
      borderRadius: 0,
      colors: _objectSpread(_objectSpread({}, theme.colors), {}, {
        primary: EmailForm_module.white,
        primary25: EmailForm_module.white
      })
    });
  }

  var genders = [{
    value: 'Άνδρας',
    label: 'Άνδρας'
  }, {
    value: 'Γυναίκα',
    label: 'Γυναίκα'
  }];

  function onChangeSelectedArea(areaSelected) {
    setSelectedArea(areaSelected);
    setValues(_objectSpread(_objectSpread({}, values), {}, {
      area: areaSelected.value
    }));
  }

  function onChangeSelectedPosition(positionSelected) {
    setSelectedPosition(positionSelected);
    setValues(_objectSpread(_objectSpread({}, values), {}, {
      position: positionSelected.value
    }));
  }

  function onChangeSelectedGender(genderSelected) {
    setSelectedGender(genderSelected);
    setValues(_objectSpread(_objectSpread({}, values), {}, {
      gender: genderSelected.value
    }));
  }

  function onChangeDate(date) {
    setStartDate(date);
    var formattedDate = dayjs_min_default()(date).format('DD/MM/YYYY');
    setValues(_objectSpread(_objectSpread({}, values), {}, {
      birthday: formattedDate
    }));
  }

  function onChangeInput(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;
    setValues(_objectSpread(_objectSpread({}, values), {}, (0,defineProperty/* default */.Z)({}, name, value)));
  }

  function onUploadFile(e) {
    var file = e.target.files[0];
    setInputText((file === null || file === void 0 ? void 0 : file.name) || '');
  }

  function onSubmit(_x) {
    return _onSubmit.apply(this, arguments);
  }

  function _onSubmit() {
    _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(e) {
      var emailCase, formParams, file, _yield$sendMail, error;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              loader/* default.addEvent */.Z.addEvent('SEND_EMAIL');
              e.preventDefault();
              emailCase = selectedSubject ? selectedSubject.value : 'default';
              formParams = new FormData();
              formParams.append('emailCase', emailCase);
              Object.entries(values).forEach(function (_ref4) {
                var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 2),
                    key = _ref5[0],
                    value = _ref5[1];

                if (value) formParams.append(key, value);
              });
              file = e.target.cv ? e.target.cv.files[0] : 0;

              if (file) {
                formParams.append('attachment', file, file.name);
              }

              _context.next = 10;
              return sendMail(formParams);

            case 10:
              _yield$sendMail = _context.sent;
              error = _yield$sendMail.error;

              if (!error) {
                _context.next = 16;
                break;
              }

              loader/* default.removeEvent */.Z.removeEvent('SEND_EMAIL');
              setModal({
                isOpen: true,
                mainText: error.userMessage || 'Δεν ήταν δυνατή η αποστολή του μηνύματός σας. Παρακαλούμε προσπαθήστε ξανά σε λίγο.',
                onClickContinue: function onClickContinue() {
                  setModal(_objectSpread(_objectSpread({}, modal), {}, {
                    isOpen: false
                  }));
                }
              });
              return _context.abrupt("return");

            case 16:
              loader/* default.removeEvent */.Z.removeEvent('SEND_EMAIL');
              setModal({
                isOpen: true,
                submitText: slug !== 'career' ? 'Συνέχεια' : 'OK',
                mainText: slug !== 'career' ? "\u03A4\u03BF \u03BC\u03AE\u03BD\u03C5\u03BC\u03AC \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C3\u03C4\u03B1\u03BB\u03B5\u03AF \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2 \u03C3\u03C4\u03BF \u03B1\u03C1\u03BC\u03CC\u03B4\u03B9\u03BF \u03C4\u03BC\u03AE\u03BC\u03B1 \u03C4\u03B7\u03C2 ".concat("ΚΡΗΤΙΚΟΣ", ".") : "\u03A3\u03B1\u03C2 \u03B5\u03C5\u03C7\u03B1\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD\u03BC\u03B5 \u03B3\u03B9\u03B1 \u03C4\u03B7\u03BD \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AF\u03B1. \u03A4\u03BF \u03B1\u03AF\u03C4\u03B7\u03BC\u03AC \u03C3\u03B1\u03C2 \u03AD\u03C7\u03B5\u03B9 \u03C5\u03C0\u03BF\u03B2\u03BB\u03B7\u03B8\u03B5\u03AF \u03B5\u03C0\u03B9\u03C4\u03C5\u03C7\u03CE\u03C2.\n          \n          \u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u0391\u03BD\u03B8\u03C1\u03CE\u03C0\u03B9\u03BD\u03BF\u03C5 \u0394\u03C5\u03BD\u03B1\u03BC\u03B9\u03BA\u03BF\u03CD \u0391\u039D\u0395\u0394\u0397\u039A \u039A\u03A1\u0397\u03A4\u0399\u039A\u039F\u03A3",
                onClickContinue: function onClickContinue() {
                  setModal(_objectSpread(_objectSpread({}, modal), {}, {
                    isOpen: false
                  }));
                  router.push('/');
                }
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _onSubmit.apply(this, arguments);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
      action: "/api/mailer",
      method: "post",
      className: (EmailForm_module_default()).emailForm,
      onSubmit: onSubmit,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (EmailForm_module_default()).header,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: (EmailForm_module_default()).title,
          children: slug === 'career' ? 'Υποβολή Βιογραφικού' : 'Στείλε μας Email'
        }), slug !== 'career' && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: "emailSubject",
            className: (EmailForm_module_default()).dropDown,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
              name: "emailSubject",
              inputId: "emailSubject",
              options: subjectOptions,
              styles: style,
              className: (EmailForm_module_default()).selectInput,
              value: selectedSubject,
              onChange: setSelectedSubject,
              placeholder: "\u0398\u03AD\u03BC\u03B1",
              components: {
                IndicatorSeparator: function IndicatorSeparator() {
                  return null;
                }
              },
              theme: setTheme
            })
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (EmailForm_module_default()).container,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          htmlFor: "lastName",
          className: (EmailForm_module_default()).labelSmaller,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (EmailForm_module_default()).text,
            children: ["\u0395\u03C0\u03CE\u03BD\u03C5\u03BC\u03BF", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (EmailForm_module_default()).span,
              children: "*"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "lastName",
            name: "lastName",
            type: "text",
            required: true,
            className: (EmailForm_module_default()).input,
            value: values.names,
            onChange: onChangeInput
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          htmlFor: "firstName",
          className: (EmailForm_module_default()).labelSmaller,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (EmailForm_module_default()).text,
            children: ["\u038C\u03BD\u03BF\u03BC\u03B1", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (EmailForm_module_default()).span,
              children: "*"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            id: "firstName",
            name: "firstName",
            type: "text",
            required: true,
            className: (EmailForm_module_default()).input,
            value: values.names,
            onChange: onChangeInput
          })]
        })]
      }), slug === 'career' && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (EmailForm_module_default()).container,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "gender",
            className: (EmailForm_module_default()).labelSmaller,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (EmailForm_module_default()).text,
              children: ["\u03A6\u03CD\u03BB\u03BF", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (EmailForm_module_default()).span,
                children: "*"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
              name: "gender",
              inputId: "gender",
              options: genders,
              styles: style,
              className: (EmailForm_module_default()).selectInput,
              value: selectedGender,
              onChange: onChangeSelectedGender,
              placeholder: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03C4\u03BF \u03C6\u03CD\u03BB\u03BF \u03C3\u03BF\u03C5",
              components: {
                IndicatorSeparator: function IndicatorSeparator() {
                  return null;
                }
              },
              theme: setTheme
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              tabIndex: -1,
              autoComplete: "off",
              className: (EmailForm_module_default()).selectHiddenInput,
              value: selectedGender,
              required: true
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "position",
            className: (EmailForm_module_default()).labelSmaller,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (EmailForm_module_default()).text,
              children: ["\u0397\u03BC. \u0393\u03AD\u03BD\u03BD\u03B7\u03C3\u03B7\u03C2", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (EmailForm_module_default()).span,
                children: "*"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((react_datepicker_min_default()), {
              className: (EmailForm_module_default()).input,
              popperClassName: (EmailForm_module_default()).calendar,
              selected: startDate,
              onChange: onChangeDate,
              dateFormat: "dd/MM/yyyy",
              showYearDropdown: true,
              dateFormatCalendar: "MMMM",
              yearDropdownItemNumber: 120,
              scrollableYearDropdown: true,
              required: true
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (EmailForm_module_default()).container,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "address",
            className: (EmailForm_module_default()).labelFullWidth,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (EmailForm_module_default()).text,
              children: "\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 \u039A\u03B1\u03C4\u03BF\u03B9\u03BA\u03AF\u03B1\u03C2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "text",
              id: "address",
              name: "address",
              className: (EmailForm_module_default()).input,
              value: values.number,
              onChange: onChangeInput
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (EmailForm_module_default()).container,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "addressNumber",
            className: (EmailForm_module_default()).labelSmaller,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (EmailForm_module_default()).text,
              children: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u039A\u03B1\u03C4\u03BF\u03B9\u03BA\u03AF\u03B1\u03C2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "text",
              id: "addressNumber",
              name: "addressNumber",
              className: (EmailForm_module_default()).input,
              value: values.number,
              onChange: onChangeInput
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "postal",
            className: (EmailForm_module_default()).labelSmaller,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (EmailForm_module_default()).text,
              children: ["\u03A4\u03B1\u03C7\u03C5\u03B4\u03C1\u03BF\u03BC\u03B9\u03BA\u03CC\u03C2 \u03BA\u03CE\u03B4\u03B9\u03BA\u03B1\u03C2", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (EmailForm_module_default()).span,
                children: "*"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "number",
              id: "postal",
              name: "postal",
              required: true,
              className: (EmailForm_module_default()).input,
              value: values.number,
              onChange: onChangeInput
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (EmailForm_module_default()).container,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "city",
            className: (EmailForm_module_default()).labelSmaller,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (EmailForm_module_default()).text,
              children: ["\u03A0\u03CC\u03BB\u03B7/\u03A0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE \u039A\u03B1\u03C4\u03BF\u03B9\u03BA\u03AF\u03B1\u03C2", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (EmailForm_module_default()).span,
                children: "*"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "text",
              id: "city",
              name: "city",
              required: true,
              className: (EmailForm_module_default()).input,
              value: values.number,
              onChange: onChangeInput
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "telephone",
            className: (EmailForm_module_default()).labelSmaller,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (EmailForm_module_default()).text,
              children: "\u03A4\u03B7\u03BB\u03B5\u03C6\u03C9\u03BD\u03B9\u03BA\u03CC\u03C2 \u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "number",
              id: "telephone",
              name: "telephone",
              className: (EmailForm_module_default()).input,
              value: values.number,
              onChange: onChangeInput
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (EmailForm_module_default()).container,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          htmlFor: "mobilePhone",
          className: (EmailForm_module_default()).labelSmaller,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (EmailForm_module_default()).text,
            children: ["\u039A\u03B9\u03BD\u03B7\u03C4\u03CC \u03A4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03BF", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (EmailForm_module_default()).span,
              children: "*"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "number",
            id: "mobilePhone",
            name: "mobilePhone",
            required: true,
            className: (EmailForm_module_default()).input,
            value: values.number,
            onChange: onChangeInput
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          htmlFor: "email",
          className: (EmailForm_module_default()).labelSmaller,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
            className: (EmailForm_module_default()).text,
            children: ["\u0394\u03B9\u03B5\u03CD\u03B8\u03C5\u03BD\u03C3\u03B7 Email", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: (EmailForm_module_default()).span,
              children: "*"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
            type: "email",
            id: "email",
            name: "email",
            required: true,
            className: (EmailForm_module_default()).input,
            value: values.email,
            onChange: onChangeInput
          })]
        })]
      }), slug === 'career' && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (EmailForm_module_default()).container,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "position",
            className: (EmailForm_module_default()).labelSmaller,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (EmailForm_module_default()).text,
              children: ["\u0398\u03AD\u03C3\u03B7", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (EmailForm_module_default()).span,
                children: "*"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
              name: "position",
              inputId: "position",
              options: availablePositions,
              styles: style,
              className: (EmailForm_module_default()).selectInput,
              value: selectedPosition,
              onChange: onChangeSelectedPosition,
              placeholder: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03BC\u03B9\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2 \u03B8\u03AD\u03C3\u03B5\u03B9\u03C2",
              components: {
                IndicatorSeparator: function IndicatorSeparator() {
                  return null;
                }
              },
              theme: setTheme
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              tabIndex: -1,
              autoComplete: "off",
              className: (EmailForm_module_default()).selectHiddenInput,
              value: selectedPosition,
              required: true
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "area",
            className: (EmailForm_module_default()).labelSmaller,
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              className: (EmailForm_module_default()).text,
              children: ["\u03A0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AE", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: (EmailForm_module_default()).span,
                children: "*"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_select_browser_esm/* default */.ZP, {
              name: "area",
              inputId: "area",
              options: availableAreas,
              styles: style,
              className: (EmailForm_module_default()).selectInput,
              value: selectedArea,
              onChange: onChangeSelectedArea,
              placeholder: "\u0395\u03C0\u03AF\u03BB\u03B5\u03BE\u03B5 \u03BC\u03B9\u03B1 \u03B1\u03C0\u03CC \u03C4\u03B9\u03C2 \u03B4\u03B9\u03B1\u03B8\u03AD\u03C3\u03B9\u03BC\u03B5\u03C2 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AD\u03C2",
              components: {
                IndicatorSeparator: function IndicatorSeparator() {
                  return null;
                }
              },
              theme: setTheme
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              tabIndex: -1,
              autoComplete: "off",
              className: (EmailForm_module_default()).selectHiddenInput,
              value: selectedArea,
              required: true
            })]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (EmailForm_module_default()).fileUpload,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
            htmlFor: "cv",
            className: (EmailForm_module_default()).label,
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
              className: (EmailForm_module_default()).text,
              children: "E\u03C0\u03B9\u03C3\u03CD\u03BD\u03B1\u03C8\u03B7 \u03B2\u03B9\u03BF\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03BF\u03CD \u03C3\u03B7\u03BC\u03B5\u03B9\u03CE\u03BC\u03B1\u03C4\u03BF\u03C2"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
              type: "file",
              name: "cv",
              id: "cv",
              accept: "application/pdf,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              className: (EmailForm_module_default()).inputUpload,
              onChange: onUploadFile
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: (EmailForm_module_default()).inputFake,
              children: inputText
            })]
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
        htmlFor: "message",
        className: (EmailForm_module_default()).label,
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (EmailForm_module_default()).text,
          children: ["\u03A4\u03BF \u039C\u03AE\u03BD\u03C5\u03BC\u03AC \u03C3\u03B1\u03C2", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: (EmailForm_module_default()).span,
            children: "*"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("textarea", {
          name: "message",
          id: "message",
          cols: "30",
          rows: "5",
          required: true,
          value: values.message,
          className: (EmailForm_module_default()).input,
          onChange: onChangeInput
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (EmailForm_module_default()).buttonContainer,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Buttons/* PrimaryButton */.KM, {
          type: "submit",
          children: "\u0391\u03C0\u03BF\u03C3\u03C4\u03BF\u03BB\u03AE \u039C\u03B7\u03BD\u03CD\u03BC\u03B1\u03C4\u03BF\u03C2"
        })
      })]
    }), modal.isOpen && /*#__PURE__*/(0,jsx_runtime.jsx)(GenericModalV2["default"], {
      mainText: modal.mainText,
      modalLabel: "Info modal",
      onClickContinue: modal.onClickContinue,
      submitText: modal.submitText
    })]
  });
}

/***/ }),

/***/ 29962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83253);
/* harmony import */ var react_modal__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_modal__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13764);
/* harmony import */ var _Buttons_Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3805);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61429);
/* harmony import */ var _GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








var CUSTOM_STYLES_V2 = {
  overlay: _objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__/* ["default"].overlay */ .Z.overlay),
  content: _objectSpread(_objectSpread({}, _utils_modalStyle__WEBPACK_IMPORTED_MODULE_3__/* ["default"].content */ .Z.content), {}, {
    outline: '0'
  })
};

function GenericModalV2(_ref) {
  var children = _ref.children,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? true : _ref$isOpen,
      _ref$mainText = _ref.mainText,
      mainText = _ref$mainText === void 0 ? '' : _ref$mainText,
      modalLabel = _ref.modalLabel,
      onClickContinue = _ref.onClickContinue,
      _ref$submitText = _ref.submitText,
      submitText = _ref$submitText === void 0 ? 'Συνέχεια' : _ref$submitText;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(isOpen),
      _isModalOpen = _useState[0],
      setIsModalOpen = _useState[1];

  var _onClickContinue = onClickContinue || closeModal;

  function closeModal() {
    setIsModalOpen(false);
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)((react_modal__WEBPACK_IMPORTED_MODULE_2___default()), {
    isOpen: _isModalOpen,
    style: CUSTOM_STYLES_V2,
    contentLabel: modalLabel,
    ariaHideApp: false,
    className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContent),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)("div", {
      className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().modalContainer),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("main", {
        children: children || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("p", {
          className: (_GenericModalV2_module_scss__WEBPACK_IMPORTED_MODULE_6___default().text),
          children: mainText
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)("footer", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(_Buttons_Buttons__WEBPACK_IMPORTED_MODULE_4__/* .PrimaryButton */ .KM, {
          onClick: _onClickContinue,
          children: [" ", submitText]
        })
      })]
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = (GenericModalV2);

/***/ }),

/***/ 36593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PageTitle; }
/* harmony export */ });
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13282);
/* harmony import */ var _PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function PageTitle(_ref) {
  var title = _ref.title,
      heading = _ref.heading;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
    className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().section),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().content),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().title),
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbs),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_0___default()), {
          href: "/",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbPrevious),
            children: "\u0391\u03C1\u03C7\u03B9\u03BA\u03AE"
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          className: (_PageTitle_module_scss__WEBPACK_IMPORTED_MODULE_2___default().breadcrumbSeparator),
          children: "/"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
          children: heading || title
        })]
      })]
    })
  });
}

/***/ }),

/***/ 13764:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var CUSTOM_STYLES = {
  overlay: {
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 9,
    backgroundColor: 'rgba(0, 0, 0, 0.3)'
  },
  content: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate3d(-50%, -50%, 0)',
    padding: 0,
    right: 'unset',
    bottom: 'unset'
  }
};
/* harmony default export */ __webpack_exports__["Z"] = (CUSTOM_STYLES);

/***/ }),

/***/ 21058:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalBorder":"1px solid #d4d4d4","inputTextColor":"#333","white":"#fff","emailForm":"EmailForm_emailForm__1Yhfp","hidden":"EmailForm_hidden__urAi6","header":"EmailForm_header__pJsig","title":"EmailForm_title__zGHCl","container":"EmailForm_container__etbUn","label":"EmailForm_label__gw5t6","labelFullWidth":"EmailForm_labelFullWidth__4bnTU","labelSmaller":"EmailForm_labelSmaller__vffJ0","dropDown":"EmailForm_dropDown___4u5v","span":"EmailForm_span__eDKBl","input":"EmailForm_input__Lb_yc","inputUpload":"EmailForm_inputUpload__plhQC","selectInput":"EmailForm_selectInput__eqX0Q","fileUpload":"EmailForm_fileUpload__BP5ML","inputFake":"EmailForm_inputFake__w7En1","buttonContainer":"EmailForm_buttonContainer__lVTq_","text":"EmailForm_text__l_4Uq","selectHiddenInput":"EmailForm_selectHiddenInput__Auyt4","submitBtn":"EmailForm_submitBtn__9Ghgu","contentLayout":"EmailForm_contentLayout__any0f","css-yk16xz-control":"EmailForm_css-yk16xz-control__JxaE8"};

/***/ }),

/***/ 61429:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"GenericModalV2_modalContainer__aCXv8","modalContent":"GenericModalV2_modalContent__Mpl98","text":"GenericModalV2_text__vXm9C","footer":"GenericModalV2_footer__YXTWC","btn":"GenericModalV2_btn__rhKmF"};

/***/ }),

/***/ 13282:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"section":"PageTitle_section__JW_pb","content":"PageTitle_content__b6zB3","title":"PageTitle_title__MR_HW","breadcrumbs":"PageTitle_breadcrumbs__yPd2_","breadcrumbSeparator":"PageTitle_breadcrumbSeparator__bNku9","breadcrumbPrevious":"PageTitle_breadcrumbPrevious__o_DvH"};

/***/ }),

/***/ 28833:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"index_headerContainer__J9svF"};

/***/ })

}]);